import { ModalInstance } from '@/types';

interface ModalQueueService {
  queue: ModalInstance[];
  domElementsCount: number;
  add(modal: ModalInstance): void;
  isExistHigherPriority(priority: number | null): boolean;
  openNext(): void;
  isReady(): boolean;
  hasOpened(): boolean;
  getOpened(): ModalInstance;
  hideOpened(): void;
  closeOpened(): void;
}

export default {
	queue: [],
	domElementsCount: 0,
	add(modal: ModalInstance) {
		this.queue.push(modal);
		this.domElementsCount++;
	},
	isExistHigherPriority(priority: number | null): boolean {
		return this.queue.some((modal: any) => modal.priorityOpen !== null && priority < modal.priorityOpen);
	},
	openNext() {
    this.queue.find((modal: ModalInstance) => modal.isPending)?.open();
	},
	isReady(): boolean {
		return this.queue.length === this.domElementsCount;
	},
	hasOpened(): boolean {
		return this.queue.some((modal: ModalInstance) => modal.isOpen);
	},
	getOpened(): ModalInstance {
		return this.queue.find((modal: ModalInstance) => modal.isOpen);
	},
	hideOpened(): void {
		const opened = this.getOpened();

		if (opened) {
			opened.isOpen = false;
			opened.isPending = true;
		}
	},
	closeOpened(): void {
		const opened = this.getOpened();
		opened && opened.close();
	}
} as ModalQueueService;
